import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import ApplicationLayout from 'v3/layouts/Application';
import Card from 'v3/components/Card';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';
import { showBusinessGroup } from '../Services';

function fmtMoney(v) {
  if (v === 0) return 'R$ 0,00';
  if (v == null) return '—';
  try {
    return Number(v).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  } catch {
    return `R$ ${v}`;
  }
}

function fmtDate(d) {
  if (!d) return '—';
  try {
    const dt = new Date(d);
    const dd = String(dt.getDate()).padStart(2, '0');
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const yyyy = dt.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch {
    return d;
  }
}

function fmtCpfCnpj(v) {
  // Novo padrão alfanumérico: CNPJ pode conter letras maiúsculas nas 12 primeiras posições
  const chars = String(v || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
  if (!chars) return '—';

  const hasLetters = /[A-Z]/.test(chars);

  if (hasLetters || chars.length === 14) {
    const c = chars.slice(0, 14);
    if (c.length < 14) return c;
    return `${c.slice(0, 2)}.${c.slice(2, 5)}.${c.slice(5, 8)}/${c.slice(8, 12)}-${c.slice(12)}`;
  }
  if (chars.length === 11) {
    return chars.replace(
      /^(\d{3})(\d{3})(\d{3})(\d{2})$/,
      '$1.$2.$3-$4',
    );
  }
  return v;
}
function DetailLoadingRow() {
  return (
    <div
      className="d-flex justify-content-center align-items-center py-4"
      role="status"
      aria-busy="true"
    >
      <Spinner
        animation="border"
        role="status"
        className="mr-3"
        style={{ color: '#9aa4ae' }}
      />
      <Text type="body" style={{ color: '#9aa4ae', fontWeight: 600 }}>
        Carregando
      </Text>
    </div>
  );
}

export default function BusinessGroupDetails() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [group, setGroup] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setGroup(await showBusinessGroup(id));
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const empresas = group?.empresasVinculadas ?? [];

  return (
    <ApplicationLayout
      title="Grupo Empresarial"
      RightComponent={
        <Button variant="secondary" onClick={() => navigate(-1)}>
          <Text type="regular" color="dark" weight="semiBold">
            Voltar
          </Text>
        </Button>
      }
    >
      <Card>
        {loading ? (
          <DetailLoadingRow />
        ) : !group ? (
          <Text>Não foi possível encontrar esse grupo.</Text>
        ) : (
          <>
            <Text as="h2" size="xl" weight="700" className="mb-3">
              {group?.nome || '—'}
            </Text>

            <Row className="mb-3 mt-4">
              <Col md={3} xs={12} className="mb-3">
                <div
                  style={{
                    borderBottom: '1px solid #E1E5EB',
                    paddingBottom: 4,
                    marginBottom: 6,
                  }}
                >
                  <Text
                    type="regular"
                    color="#464E5F"
                    weight="600"
                    fontSize={14}
                    style={{ display: 'block' }}
                  >
                    CNPJ principal
                  </Text>
                </div>

                <Text
                  type="regular"
                  color="gray"
                  as="p"
                  className="mt-1"
                  fontSize={14}
                >
                  {fmtCpfCnpj(group?.cnpjPrincipal)}
                </Text>
              </Col>

              <Col md={3} xs={12} className="mb-3">
                <div
                  style={{
                    borderBottom: '1px solid #E1E5EB',
                    paddingBottom: 4,
                    marginBottom: 6,
                  }}
                >
                  <Text
                    type="regular"
                    color="#464E5F"
                    weight="600"
                    fontSize={14}
                    style={{ display: 'block' }}
                  >
                    Vencimento
                  </Text>
                </div>

                <Text
                  type="regular"
                  color="gray"
                  as="p"
                  className="mt-1"
                  fontSize={14}
                >
                  {fmtDate(group?.vencimento || group?.vencimentoLimite)}
                </Text>
              </Col>

              <Col md={3} xs={12} className="mb-3">
                <div
                  style={{
                    borderBottom: '1px solid #E1E5EB',
                    paddingBottom: 4,
                    marginBottom: 6,
                  }}
                >
                  <Text
                    type="regular"
                    color="#464E5F"
                    weight="600"
                    fontSize={14}
                    style={{ display: 'block' }}
                  >
                    Valor liberado
                  </Text>
                </div>

                <Text
                  type="regular"
                  color="gray"
                  as="p"
                  className="mt-1"
                  fontSize={14}
                >
                  {fmtMoney(group?.valorLiberado)}
                </Text>
              </Col>

              <Col md={3} xs={12} className="mb-3">
                <div
                  style={{
                    borderBottom: '1px solid #E1E5EB',
                    paddingBottom: 4,
                    marginBottom: 6,
                  }}
                >
                  <Text
                    type="regular"
                    color="#464E5F"
                    weight="600"
                    fontSize={14}
                    style={{ display: 'block' }}
                  >
                    Valor permitido
                  </Text>
                </div>

                <Text
                  type="regular"
                  color="gray"
                  as="p"
                  className="mt-1"
                  fontSize={14}
                >
                  {fmtMoney(group?.valorPermitido)}
                </Text>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col md={3} xs={12}>
                <div
                  style={{
                    borderBottom: '1px solid #E1E5EB',
                    paddingBottom: 4,
                    marginBottom: 6,
                  }}
                >
                  <Text
                    type="regular"
                    color="#464E5F"
                    weight="600"
                    fontSize={14}
                    style={{ display: 'block' }}
                  >
                    Empresas
                  </Text>
                </div>

                <Text
                  type="regular"
                  color="gray"
                  as="p"
                  className="mt-1"
                  fontSize={14}
                >
                  {Array.isArray(empresas) ? empresas.length : 0}
                </Text>
              </Col>
            </Row>

            <Text as="h3" size="lg" weight="600" className="mt-2">
              CNPJs vinculados
            </Text>

            <Row className="mt-2">
              {Array.isArray(empresas) && empresas.length ? (
                empresas.map((empresa) => (
                  <Col
                    md={6}
                    xs={12}
                    key={empresa.id || empresa.cnpj}
                    className="mb-3"
                  >
                    <Card className="p-3">
                      <div
                        style={{
                          borderBottom: '1px solid #E1E5EB',
                          paddingBottom: 4,
                          marginBottom: 6,
                        }}
                      >
                        <Text
                          type="regular"
                          color="#464E5F"
                          weight="600"
                          fontSize={14}
                          style={{ display: 'block' }}
                        >
                          {empresa.nome || '—'}
                        </Text>
                      </div>

                      <Text
                        type="regular"
                        color="gray"
                        as="p"
                        className="mt-1"
                        fontSize={14}
                      >
                        {fmtCpfCnpj(empresa.cnpj)}
                      </Text>
                    </Card>
                  </Col>
                ))
              ) : (
                <Col xs={12}>
                  <Text type="regular" color="gray">
                    Nenhuma empresa vinculada.
                  </Text>
                </Col>
              )}
            </Row>
          </>
        )}
      </Card>
    </ApplicationLayout>
  );
}
